module.exports = __webpack_public_path__ + "img/LTC.d77aee66.png";